/** @type {Record<string,string>} */
export const ERROR_MESSAGE = {
    UNKNOWN: "알 수 없는 에러가 발생하였습니다. 관리자에게 문의해주세요.",
    SERVER_DATABASE_ERROR: "서버 DB 에러가 발생하셨습니다.",
    NOT_EXIST_AUTH_TOKEN: "토큰이 존재하지 않습니다. 로그인 페이지에서 재로그인 해보시기 바랍니다.",
    AUTH_TOKEN_EXPIRED: "토큰이 만료되었습니다. 로그인 페이지에서 재로그인 해보시기 바랍니다.",
    NOT_EXIST_USER: "계정 정보가 존재하지 않습니다.",
    WRONG_PASSWORD: "비밀번호가 잘못되었습니다.",
    NOT_EXIST_CAFE24_TOKEN: "카페24 토큰이 존재하지 않습니다. 카페24 관리자 페이지에서 앱을 다시 열어주세요.",
    NOT_EXIST_FOLDER: "폴더가 존재하지 않습니다. 페이지 리로드 후 다시 확인해주세요.",
    NOT_EXIST_PARENT_FOLDER: "상위 폴더가 존재하지 않습니다. 페이지 리로드 후 다시 확인해주세요.",
    NOT_EXIST_FILE: "파일이 존재하지 않습니다. 페이지 리로드 후 다시 확인해주세요.",
    DUPLICATE_FOLDER_NAME: "중복된 폴더명입니다. 폴더명을 변경해주세요.",
    VALIDATE_FOLDER_NAME: "폴더명이 유효하지 않습니다. 폴더명을 변경해주세요.",
    MAX_FOLDER_DEPTH: "폴더는 최대 4depth 까지 생성할 수 있습니다.",
    ALREADY_EXIST_FILE_NAME: "중복된 파일명입니다.",
    ALREADY_EXIST_USER_ID: "중복된 계정명입니다. 계정명을 변경해주세요.",
    NOT_EXIST_BOOKMARK: "즐겨찾기가 존재하지 않습니다.",
    NOT_ALLOWED_THIS_ACTION: "권한이 없습니다. 관리자에게 문의 부탁드립니다.",
    WRONG_AFFILIATION_NAME: "잘못된 소속입니다.",
    WRONG_TEAM_NAME: "잘못된 팀명입니다.",
    NOT_EXIST_PERMISSION_GROUP: "해당 권한 그룹이 존재하지 않습니다.",
    NOT_EXIST_PERMISSION_NAME: "해당 이름의 권한이 존재하지 않습니다.",
    NOT_EXIST_CONNECTED_BOARD: "연결 보드가 존재하지 않습니다.",
    NOT_EXIST_PRODUCT: "상품이 존재하지 않습니다.",
    NOT_EXIST_NOTIFICATION: "알림이 존재하지 않습니다.",
    NOT_EXIST_PAGE: "페이지가 존재하지 않습니다.",
    NOT_EXIST_BOARD: "보드가 존재하지 않습니다.",
    NOT_EXIST_COMMENT: "댓글이 존재하지 않습니다.",
    NOT_EXIST_PARENT_COMMENT: "상위 댓글이 존재하지 않습니다.",
    NOT_EXIST_BOOKMARK_PATH: "즐겨찾기 경로가 존재하지 않습니다.",
    FAIL_UPLOAD_S3: "업로드에 싪패했습니다. 관리자에게 문의 주세요.",
    ALREADY_EXIST_PRODUCT_LINK: "이미 상품 연결이 되어 있습니다.",
    NOT_EXIST_PRODUCT_LINK: "상품 연결이 존재하지 않습니다.",
    MOVE_SAME_PATH: "동일한 경로로는 이동 할 수 없습니다."
}